import Cookie from "common/util/cookie";

/**
 * 디스플레이 모드를 변경하는 클래스 (PC버전 <-> 모바일버전)
 */
export default class displayMode {
    /**
     * 예외 처리할 도메인들 (WWW <-> M은 어플리케이션이 다르므로 최상위 경로로 redirect)
     * @type {{pc: string, mobile: string}}
     */
    excepts = {
        'pc': 'WWW',
        'mobile': 'M',
    };

    /**
     * 생성자
     * @param to
     */
    constructor(to) {
        this.to = to;
        if(this.to === 'pc') {
            this.from = 'mobile';
        } else {
            this.from = 'pc';
        }
        this.current = new URL(window.location.href);
    }

    /**
     * 예외 처리할(최상위 경로로 보낼) URL인지 검사한다.
     *
     * @returns {boolean}
     */
    isExcept() {
        let exceptUrl = process.env[`REACT_APP_${this.excepts[this.from]}_URL`];
        if(exceptUrl.substring(0, 2) === '//') {
            exceptUrl = 'https:'+exceptUrl;
        }
        const urlObj = new URL(exceptUrl);
        const hostname = urlObj.hostname;
        if(this.current.hostname === hostname) {
            return true;
        }
        return false;
    }

    /**
     * PC버전으로 보기시 사용할 쿠키 값을 세팅한다.
     */
    setCookies() {
        let cv = '';
        let expires = 0;
        if(this.to === 'pc') {
            cv = 'pc';
            expires = -1;
        }
        Cookie.set('displayMode', cv, expires, '/', `.pping.${process.env.REACT_APP_TLD}`);
        Cookie.set('forceDisplayMode', cv, expires, '/', `.pping.${process.env.REACT_APP_TLD}`);
    }

    /**
     * 디스플레이 모드를 변경한다.
     */
    set() {
        this.setCookies();
        if(this.isExcept() === true) {
            window.location.href = process.env[`REACT_APP_${this.excepts[this.to]}_URL`];
        } else {
            window.location.href = this.current.href;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/util/displayMode.js